import { Component, HostListener, ElementRef, ViewContainerRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouterModule, Router } from '@angular/router';
import { NgbModal, NgbActiveModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ResetPasswordPage } from './employeeActions/resetPasswordByAdmin';
import { ActionSuspend } from './employeeActions/actionSuspend';
import { SharedData } from '../shared/sharedData';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import * as _ from 'underscore';
import { Auth } from '../shared/services/auth';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToasterComponent } from '../toasterComponent/toasterComponent';
import { ConfirmationComponent } from '../confirmation/confirmation';
import { TreeviewItem, TreeviewConfig } from 'ngx-treeview';
import { Location } from '@angular/common';
import { ScheduleAnnouncement } from '../programManagement/announcements/scheduleAnnouncement';
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';


@Component({
    selector: 'EmployeeSearch',
    templateUrl: 'employeeSearch.html',
})



export class EmployeeSearch implements OnInit {

    closeResult: any;
    showButtonLoading: any = false;
    public displayType = "";
    public type = "";
    public programId = "";
    public option = "";
    public roleId: any;
    public groupId: any;
    public notValidForTrigger = [];
    public startpayload = {
        programId: null,
        employeeSearchFilter: null,
        participantsType: null
    };

    public triggerPayload: any = {
        reviewEndDate: null,
        programId: null,
        isFinal: false,
        employeeSearchFilter: null,
        reviewTriggerId: null
    };

    public announcementData = {
        employeeSearchFilter: null,
        participantsType: null,
        contentData: {
            text: null,
            imgURL: [],
            videoURL: [],
            imageURL: [],
            extensions: [],
            imgWebAddress: null
        },
        groupIds: [],
        title: null,
        activationDate: null
    };
    public switchEmployeeDetails: any = {};
    public invalidEmp: any = [];
    public userGroupdata = {
        id: null,
        name: null,
        description: null,
        version: null,
        roleGroups: [],
        userGroups: [],
    };
    public enrollProgramId: any = [];
    public enrollEmployeesPayload = {
        programId: null,
        employeeSearchFilter: null,
        participantsType: null
    }
    public enrollProgramData: any = {};
    public enrollProgramType: any;


    constructor(
        public route: ActivatedRoute,
        public modalService: NgbModal,
        public router: Router,
        public _global: Configuration,
        public http: HttpClientCustom,
        public _auth: Auth,
        public eRef: ElementRef,
        public share: SharedData,
        public _sanitizer: DomSanitizer,
        public builder: FormBuilder,
        public _toaster: ToasterComponent,
        public _location: Location,
        public vcr: ViewContainerRef,
        public translate: TranslateService
    ) {
        this._baseUrl = _global.get("EPMS_BASE_URL");
        this.getEmployee();
        this._toaster.setViewRef(vcr);
        this.currentPage = 1;
        this.enrollProgramData = this.share.getMapValues('enrollData');
        if (this.enrollProgramData != undefined) {
            this.enrollProgramId = this.enrollProgramData.programId;
            this.enrollProgramType = this.enrollProgramData.type;
        }
        let startData: any = this.share.getMapValues('startProgramData');
        let triggerData: any = this.share.getMapValues('triggerReview');
        let announcementInfo: any = this.share.getMapValues('announcement');
        let roleInfo: any = this.share.getMapValues('Role');
        let userInfo: any = this.share.getMapValues('UserGroup');

        if (_.isEmpty(startData) && _.isEmpty(triggerData) && _.isEmpty(announcementInfo) && !(roleInfo) && !(userInfo) && _.isEmpty(this.enrollProgramId)) {
            this._location.back();
        }
        else {
            if (startData != null) {
                if (startData.type == 'SWITCH') {
                    this.type = startData.type;
                    this.switchEmployeeDetails = startData.employee;
                    this.displayType = "SWITCH"
                } else {
                    this.type = startData.type;
                    this.programId = startData.programId;
                    this.displayType = "Start"
                }
            }
            if (this.enrollProgramId != null && this.enrollProgramType == 'PERFORMANCE_PROGRAM') {
                this.enrollEmployeesPayload.programId = this.enrollProgramId;
                this.programId = this.enrollProgramId;
                this.displayType = "EnrollPerformance"
                this.type = "PERFORMANCE_PROGRAM";
            }
            if (this.enrollProgramId != null && this.enrollProgramType == 'COMPETENCY_PROGRAM') {
                this.programId = this.enrollProgramId;
                this.enrollCompetency.programId = this.enrollProgramId;
                this.displayType = "EnrollCompetency"
                this.type = "COMPETENCY_PROGRAM";
            }
            if (this.enrollProgramId != null && this.enrollProgramType == 'CHECKIN_PROGRAM') {
                this.programId = this.enrollProgramId;
                this.enrollCompetency.programId = this.enrollProgramId;
                this.displayType = "EnrollCheckin"
                this.type = "CHECKIN_PROGRAM";
            }
            if (triggerData != null) {
                this.triggerPayload = triggerData.payload;
                this.programId = triggerData.payload.programId;
                this.option = triggerData.option;
                this.type = "Trigger Review";
                this.displayType = "Trigger"
            }
            if (announcementInfo != null) {
                this.announcementData = announcementInfo;
                this.type = "Announcement";
                this.displayType = "Announcement"
            }
            if (roleInfo != null) {
                this.roleId = roleInfo;
                this.type = "Role";
                this.displayType = "Role"
            }
            if (userInfo != null) {
                this.groupId = userInfo;
                this.type = "UserGroup";
                this.displayType = "UserGroup"
            }

        }
    }


    finalAddRole(option) {
        let that = this;
        let flag = false;
        option = 'assignRolesIncludeEmployeeCodes';
        let url = that._baseUrl + 'v1/webAdmin/role/' + option + '/' + that.roleId;
        that.http.post(url, that.searchData).subscribe((result) => {
            if (result.status) {
                this.translate.get('usersAdded').subscribe((msg) => {
                    that._toaster.showSuccess(msg);
                });

                setTimeout(() => this.goToBackPage(), 3000);
            } else {
                this.translate.get(result.errorMessages[0]).subscribe((msg) => {
                    that._toaster.showError(msg);
                });
            }
        });
    }

    finalAddUsers(option) {
        let that = this;
        let flag = false;
        option = 'assignGroupIncludeEmployeeCodes';
        let url = that._baseUrl + 'v1/hub/userGroup/' + option + '/' + that.groupId;
        that.http.post(url, that.searchData).subscribe((result) => {
            if (result.status) {
                this.translate.get('usersAdded').subscribe((msg) => {
                    that._toaster.showSuccess(msg);
                });
                setTimeout(() => this.goToBackPage(), 3000);
            } else {
                this.translate.get(result.errorMessages[0]).subscribe((msg) => {
                    that._toaster.showError(msg);
                });
            }
        });
    }


    triggerAnnouncement() {
        let self = this;
        this.showButtonLoading = true;
        let url = self._baseUrl + "v1/webAdmin/announcement/triggerAnnouncement";
        self.check(url).subscribe((result) => {
            if (result[0].success) {
                this.translate.get('announcementSuccessfull').subscribe((msg) => {
                    self._toaster.showSuccess(msg);
                });

                this.searchData.employeeCodes = [];
                this.searchData.excludedEmployeeCodes = [];
                this.announcementData.employeeSearchFilter = null;
                setTimeout(() => self.goToBackPage(), 1000);
            } else {
                this.translate.get('invalidEmpCodeRequest').subscribe((msg) => {
                    self._toaster.showError(msg);
                });

                this.empCodeValues = '';
                this.searchData.employeeCodes = [];
                this.searchData.excludedEmployeeCodes = [];
                this.announcementData.employeeSearchFilter = null;
                /* setTimeout(() => self.goToBackPage(), 1000); */
            }
        }, (error) => {
            this.translate.get('errorWhileAnnouncement').subscribe((msg) => {
                self._toaster.showError(msg);
            });

            setTimeout(() => self.goToBackPage(), 1000);
        })
    }

    check(url): Observable<any> {
        let self = this;
        try {
            return Observable.create((observer: any) => {
                self.announcementData.employeeSearchFilter = self.searchData;
                let obs = forkJoin([self.http.post(url, self.announcementData)]);
                obs.subscribe((response: any) => {
                    observer.next(response)
                    observer.complete();
                })
            })
        } catch (e) {
            console.log("getAllEmployeeData error catch", e);
        }
    }

    validateEmps(flag) {
        if (flag == 1) {
            this.triggerAnnouncement();
        } else {
            this.scheduleAnnouncement(this.announcementData);
        }
    }

    scheduleAnnouncement(announcementData) {
        announcementData.employeeSearchFilter = this.searchData;
        this.share.saveData(announcementData);
        const modalRef = this.modalService.open(ScheduleAnnouncement).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
            if (result == 'confirmed') {
                this.goToBackPage();
            }
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }


    validateAndTrigger() {
        if (this.option == 'existing') {
            this.validateTriggerReview();
        }
        if (this.option == 'new') {
            this.triggerReview('new');
        }
    }

    goToBackPage() {
        if (this.type == 'CHECKINS_PROGRAM') {
            this.router.navigate(['menu/Checkins']);
            this.share.saveAsMap('startProgramData', null);
        } else if (this.type == 'PERFORMANCE_PROGRAM') {
            this.router.navigate(['menu/performanceProgram']);
            this.share.saveAsMap('startProgramData', null);
        } else if (this.type == 'COMPETENCY_PROGRAM') {
            this.router.navigate(['menu/competencyProgram']);
            this.share.saveAsMap('startProgramData', null);
        }else if (this.type == 'CHECKIN_PROGRAM') {
            this.router.navigate(['menu/Checkins']);
            this.share.saveAsMap('startProgramData', null);
        }
         else if (this.type == 'Trigger Review') {
            this.share.saveAsMap('triggerReview', null);
            this.router.navigate(['menu/performanceProgram']);
        } else if (this.type == 'Announcement') {
            this.share.saveAsMap('announcement', null);
            this.router.navigate(['menu/announcementProgram']);
        } else if (this.type == 'Role') {
            this.share.saveAsMap('Role', null);
            this.router.navigate(['menu/rolesAndPermission']);
        } else if (this.type == 'UserGroup') {
            this.share.saveAsMap('UserGroup', null);
            this.router.navigate(['menu/userGroup']);
        } else if (this.type == "Enroll") {
            this.share.saveAsMap('enrollProgramId', null);
            this.router.navigate(['menu/performanceProgram']);
        }
    }

    validateTriggerReview() {
        try {
            this.showButtonLoading = true;
            this.triggerPayload.programId = this.programId;
            this.triggerPayload.employeeSearchFilter = this.searchData;
            let url = this._baseUrl + 'v1/webAdmin/performance/validateTriggerReview';
            this.http.post(url, this.triggerPayload).subscribe((result) => {
                if (result.length > 0) {
                    this.getOnlyValidEmpCode(result);
                } else {
                    this.translate.get('reviewTriggerFailed').subscribe((msg) => {
                        this._toaster.showError(msg);
                    });
                    this.showButtonLoading = false;
                }
            });

        } catch (e) {
            console.log('validateTriggerReview error catch', e);
        }
    }

    public getOnlyValidEmpCode(data) {
        let validEmpCode = [];
        let notExistEmp = [];
        let errorMessage: any;
        let allreadyTriggerEmp = [];
        let isVaidEmp: boolean = false;
        let self = this;
        _.each(data, function (val) {
            if (val.validationMessage == 'VALID') {
                validEmpCode.push(val.empCodes);
            }
            if (val.validationMessage == 'NOT_EXIST_IN_SYSTEM') {
                notExistEmp.push(val.empCodes);
                self.translate.get(val.validationMessage).subscribe((msg) => {
                    errorMessage = msg;
                });
                self.goToBackPage();
            }
            if (val.validationMessage == 'REVIEW_ALREADY_TRIGGERED') {
                notExistEmp.push(val.empCodes);
                self.translate.get(val.validationMessage).subscribe((msg) => {
                    errorMessage = msg;
                });
                self.goToBackPage();
            }

        });

        self.notValidForTrigger = notExistEmp;
        if (notExistEmp.length > 0) {
            isVaidEmp = false;
        } else {
            if (validEmpCode.length > 0) {
                isVaidEmp = true;
            }
        }

        if (isVaidEmp) {
            self.triggerReview('existing');
        } else {
            self.showButtonLoading = false;
            self._toaster.showError(errorMessage);
        }
    }

    triggerReview(option) {
        try {
            this.showButtonLoading = true;
            this.triggerPayload.programId = this.programId;
            this.triggerPayload.employeeSearchFilter = this.searchData;
            let url = this._baseUrl + 'v1/webAdmin/performance/triggerReview';
            this.http.post(url, this.triggerPayload).subscribe((result) => {
                if (result) {
                    if (option == 'existing') {

                        this.translate.get('reviewTriggeredForValidEmp').subscribe((msg) => {
                            this._toaster.showSuccess(msg);
                        });

                    } else {
                        this.translate.get('reviewTriggered').subscribe((msg) => {
                            this._toaster.showSuccess(msg);
                        });

                    }
                } else {
                    this.translate.get('reviewAlreadyTriggered').subscribe((msg) => {
                        this._toaster.showError(msg);
                    });

                }
                setTimeout(() => this.goToBackPage(), 3000);
            });
        } catch (e) {
            console.log('triggerReview error catch', e);
        }
    }


    startProgram(program) {
        this.showButtonLoading = true;
        let confirmData: any = {
            type: 'Start',
            program: program
        }
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent, { windowClass: 'min-modal' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
            if (result == 'confirmed') {
                this.confirmStart();
            }
        }, (reason) => {
            this.showButtonLoading = false;
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    confirmStart() {
        let self = this;
        if (this.type == 'CHECKINS_PROGRAM') {
            self.startCheckinProgram();
        } else if (this.type == 'PERFORMANCE_PROGRAM') {
            self.startPerformanceProgram();
        } else if (this.type == 'COMPETENCY_PROGRAM') {
            self.startCompetencyProgram();
        }
    }

    goToValBackPage() {
        this._location.back();
    }




    showSearchFilter(event) {
        this.searchData = event;
        this.getEmployee();
    }


    public startPerformanceProgram() {
        try {
            let data: any = this.share.getMapValues('startProgramData');
            this.startpayload.programId = data.programId;
            this.startpayload.participantsType = 'INCLUDE_EVERYONE_IN';
            this.startpayload.employeeSearchFilter = this.searchData;
            let url = this._baseUrl + 'v1/webAdmin/performance/startPerformanceProgram';
            this.http.post(url, this.startpayload).subscribe((result) => {
                if (result.success) {
                    this.translate.get('progStarted').subscribe((msg) => {
                        this._toaster.showSuccess(msg);
                    });

                    setTimeout(() => this.goToBackPage(), 3000);
                } else {
                    this.translate.get('errorWhileStartingProg').subscribe((msg) => {
                        this._toaster.showError(msg);
                    });
                    this.showButtonLoading = false;
                }
            });

        } catch (e) {
            console.log('start program error catch', e);
        }
    }
    public startCompetencyProgram() {
        try {
            let data: any = this.share.getMapValues('startProgramData');
            this.startpayload.programId = data.programId;
            this.startpayload.participantsType = 'INCLUDE_EVERYONE_IN';
            this.startpayload.employeeSearchFilter = this.searchData;
            let url = this._baseUrl + 'v1/webAdmin/competency/startCompetencyProgram';
            this.http.post(url, this.startpayload).subscribe((result) => {
                if (result.success) {
                    this.translate.get('progStarted').subscribe((msg) => {
                        this._toaster.showSuccess(msg);
                    });
                    setTimeout(() => this.goToBackPage(), 3000);
                } else {
                    this.translate.get('errorWhileStartingProg').subscribe((msg) => {
                        this._toaster.showError(msg);
                    });
                    this.showButtonLoading = false;
                    // setTimeout(() => this.goToBackPage(), 3000);
                }

            });

        } catch (e) {
            console.log('start program error catch', e);
        }
    }
    public startCheckinProgram() {
        try {
            let data: any = this.share.getMapValues('startProgramData');
            this.startpayload.programId = data.id;
            this.startpayload.participantsType = 'INCLUDE_EVERYONE_IN';
            this.startpayload.employeeSearchFilter = this.searchData;
            let url = this._baseUrl + 'v1/webAdmin/checkins/activateCheckin';
            this.http.post(url, this.startpayload).subscribe((result) => {
                if (result.success) {
                    this.translate.get('progStarted').subscribe((msg) => {
                        this._toaster.showSuccess(msg);
                    });
                    setTimeout(() => this.goToBackPage(), 3000);
                } else {
                    this.translate.get('errorWhileStartingProg').subscribe((msg) => {
                        this._toaster.showError(msg);
                    });
                    setTimeout(() => this.goToBackPage(), 3000);
                }
            });

        } catch (e) {
            console.log('start program error catch', e);
        }
    }

    public getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
    public empCodeValues: any = '';
    public excludeEmpCodeValues: any = '';
    ngOnInit() {


    }

    public page = 5;
    public endingPage = 0;
    public startingPage = 0;
    public localState = { value: '' };
    public _baseUrl: any;
    public employeeData: any = [];
    public employeePageData: any = [];
    public trackHides = null;
    public designationModel: any = {
        id: null,
        name: ''
    };
    public organizationModel: any = {
        id: null,
        orgName: ''
    };
    public orgName: string = '';
    public desigName: String = '';
    public displayName: String = '';
    public primarySupervisorModel: any = {
        id: null,
        displayName: ''
    };
    public employeeCode: any;
    public showAdvanceSearch: any = false;
    public pageSize: any = 10;
    public showLoading: any = false;
    public currentPage: any;
    public searchData = {
        "nameOrCodeOrEmail": "",
        "employeeCodes": [],
        "excludedEmployeeCodes": [],
        "includeEmpIds": [],
        "excludeEmpIds": [],
        "gradeIds": [],
        "mgrLevelIds": [],
        "designationIds": [],
        "categoryIds": [],
        "includeOrgIds": [],
        "excludeOrgIds": [],
        "supervisorIds": [],
        "primarySupervisorIds": [],
        "primarySupervisorNameOrCode": null,
        "primarySupervisorCods": [],
        "employeeStatus": null,
        "employeesWithOutSupervisor": null,
        "scorecardStates": null,
        "memberShipState": null,
        "programId": null,
        "pageSize": 10,
        "page": 1,
        "fetchSupervisorLevels": 0
    }
    public enrollCompetency: any = {
        employeeIdList: [],
        employeeSearchFilter: this.searchData,
        programId: null,
        type: "Enroll"
    }



    addEmployees() {
        this.share.saveData({ employeeId: null, type: 'ADD' });
        this.router.navigate(['menu/addEmployee']);
    }




    //patch for pop-over issue
    @HostListener('window:click', ['$event'])
    clickOut(event) {
        if (this.eRef.nativeElement.contains(event.target)) {
        } else {
            setTimeout(() => {
                this.trackHides = null;
            }, 100)
        }
    }
    clicked() {
        this.trackHides = null;
    }

    public closeEmployeeFilter() {
        this._auth.closeFilter();
    }

    //Show Advance Search 
    showAdvanced(e) {
        this.showAdvanceSearch = e;
    }


    searchEmployeeCods(e) {
        if (e == "") {
            this.searchData.employeeCodes = [];
        } else {
            this.searchData.employeeCodes[0] = e;
        }
    }

    //to get list of Organization based on keyword
    organizationObservableSource = (keyword: any): Observable<any[]> => {
        try {
            let url = this._baseUrl + "v1/webAdmin/employee/orgSearch";
            url += "?searchString=" + keyword;
            if (keyword) {
                return this.http.get(url)
                    .map(res => {
                        return res;
                    })
            } else {
                return Observable.of([]);
            }
        } catch (e) { }

    }
    //to get list of designation based on keyword
    designationObservableSource = (keyword: any): Observable<any[]> => {
        try {
            let url = this._baseUrl + "v1/webAdmin/employee/designationSearch";
            url += "?searchString=" + keyword;
            if (keyword) {
                return this.http.get(url)
                    .map(res => {
                        return res;
                    })
            } else {
                return Observable.of([]);
            }
        } catch (e) { }
    }
    //to get list of supervisor based on keyword
    primarySupervisorObservableSource(keyword: any) {
        try {
            let payload = {
                searchString: null,
                excludeEmpIds: []
            };
            payload.searchString = keyword;
            let url = this._baseUrl + "v1/webAdmin/employee/supervisorSearch";
            if (keyword) {
                return this.http.post(url, payload)
                    .map(res => {
                        return res;
                    })
            } else {
                return Observable.of([]);
            }
        } catch (e) {
        }
    }

    autoCompleteListFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.displayName}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    autoCompleteListGradeFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.name}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }
    autoCompleteListOrgFormatter = (data: any): SafeHtml => {
        let html = `<span>${data.orgName}</span>`;
        return this._sanitizer.bypassSecurityTrustHtml(html);
    }

    public orgChange(e) {
        this.orgName = e.target.value;
    }

    public orgSelected() {
        if (this.orgName === '') {
            this.organizationModel = {
                id: null,
                orgName: ''
            };
            this.searchData.includeOrgIds = [];
        } else {

            if (this.organizationModel != '') {
                this.searchData.includeOrgIds = [this.organizationModel.id];
            }
            else {
                this.searchData.includeOrgIds = [];
            }
        }
    }

    public desigChange(e) {
        this.desigName = e.target.value;
    }

    public desigSelected() {
        if (this.desigName === '') {
            this.designationModel = {
                id: null,
                name: ''
            };
            this.searchData.designationIds = [];
        } else {
            if (this.designationModel != '') {
                this.searchData.designationIds = [this.designationModel.id];
            }
            else {
                this.searchData.designationIds = [];
            }
        }
    }

    public supChange(e) {
        this.displayName = e.target.value;
    }

    public supSelected() {
        if (this.displayName === '') {
            this.primarySupervisorModel = {
                id: null,
                displayName: ''
            };
            this.searchData.supervisorIds = [];
        } else {

            if (this.primarySupervisorModel != '') {
                this.searchData.supervisorIds = [this.primarySupervisorModel.id];
            }
            else {
                this.searchData.supervisorIds = [];
            }
        }
    }

    gotNewValue(e, type) {
        let d: string;
        if (e.id != undefined) {
            d = (e.id.toString());
        }
        if (type == 'designation') {
            if (this.designationModel == "") {
                this.searchData.designationIds = [];
                return;
            }
            this.searchData.designationIds[0] = d;
        }
        if (type == 'organization') {
            if (this.organizationModel == "") {
                this.searchData.includeOrgIds = [];
                return;
            }
            this.searchData.includeOrgIds[0] = d;
        }
        if (type == 'primary') {
            if (this.primarySupervisorModel == "") {
                this.searchData.supervisorIds = [];
                return;
            }
            this.searchData.supervisorIds[0] = d;
        }
    }

    onStatusChange(e) {
        if (e == "") {
            this.searchData.employeeStatus = null;
            return;
        } else {
            this.searchData.employeeStatus = e;
        }
    }

    getEmployeeDataByKeywords() {
        let self = this;
        self.showLoading = true;
        let url = self._baseUrl + "v1/webAdmin/employee/searchEmployee";
        self.http.post(url, this.searchData).subscribe((result) => {
            self.employeeData = [];
            self.employeeData = result.content;
            self.employeePageData = result;
            self.showLoading = false;
        }, (error) => {
            console.log("getAllEmployeeData error catch", error);
        });
    }
    getEmployee() {
        try {
            let self = this;
            self.showLoading = true;
            let url = self._baseUrl + "v1/webAdmin/employee/searchActiveEmployee";
            this.searchData.employeeStatus = 1;
            self.http.post(url, this.searchData).subscribe((result) => {
                self.employeeData = [];
                self.employeeData = result.content;
                self.employeePageData = result;
                self.showLoading = false;
            });
        } catch (e) {
            console.log("getAllEmployeeData error catch", e);
        }
    }

    onPageSizeChange() {
        this.searchData.page = 1
        this.getEmployee();
    }

    public empTableActions(value) {
        if (this.trackHides == value) {
            this.trackHides = null;
        } else {
            this.trackHides = value;
        }

    }

    empTableResetPwd(id) {
        this.trackHides = null;
        this.share.saveData(id);
        const modalRef = this.modalService.open(ResetPasswordPage, { windowClass: 'min-modal' });
    }

    actionSuspend(id) {
        let closeResult: any;
        this.trackHides = null;
        this.share.saveData({ employeeId: id, type: 'SUSPEND' });
        const modalRef = this.modalService.open(ActionSuspend, { windowClass: 'min-modal' }).result.then((result) => {
            closeResult = `Closed with: ${result}`;
            if (result == 'confirm') {
                this.getEmployee();
            } else {
                // this.saveUpdateEmpRules(result);
            }
        }, (reason) => {
            closeResult = `Dismissed`;
        });
    }

    actionActive(id) {
        let closeResult: any;
        this.trackHides = null;
        this.share.saveData({ employeeId: id, type: 'ACTIVE' });
        const modalRef = this.modalService.open(ActionSuspend, { windowClass: 'min-modal' }).result.then((result) => {
            closeResult = `Closed with: ${result}`;
            if (result == 'confirm') {
                this.getEmployee();
            } else {
                // this.saveUpdateEmpRules(result);
            }
        }, (reason) => {
            closeResult = `Dismissed`;
        });
    }
    actionResign(id) {
        let closeResult: any;
        this.trackHides = null;
        let confirmData: any = {
            type: 'Resign',
            program: id
        }
        this.share.saveData(confirmData);
        const modalRef = this.modalService.open(ConfirmationComponent, { windowClass: 'min-modal' }).result.then((result) => {
            closeResult = `Closed with: ${result}`;
            if (result == 'confirmed') {
                this.getEmployee();
            } else {
                // this.saveUpdateEmpRules(result);
            }
        }, (reason) => {
            closeResult = `Dismissed`;
        });
    }


    editEmployeeProfile(id) {
        this.trackHides = null;
        this.share.saveData({ employeeId: id, type: 'EDIT' });
        this.router.navigate(['menu/addEmployee']);
    }

    assignSwitchUserPermission() {
        try {
            let payload: any = {};
            payload.employeeSearchFilter = this.searchData;
            payload.employeeSearchFilter.pageSize = null;
            let url = this._baseUrl + 'v1/webAdmin/switchEmpAccess/employeeId/' + this.switchEmployeeDetails.id;
            this.http.post(url, this.searchData).subscribe((result) => {
                this.translate.get('addedUser').subscribe((msg) => {
                    this._toaster.showSuccess(msg);
                    this.router.navigate(['menu/employeesList']);
                });
                setTimeout(() => this.goToBackPage(), 500);
            });
        } catch (e) {
            console.log('start program error catch', e);
        }
    }



    public enrollEmployeesConfirm() {
        let confirmData: any = {
            type: 'Enroll'
        }
        this.share.saveData(confirmData);
        this.modalService.open(ConfirmationComponent).result.then((result) => {
          
            if (result == 'confirmed') {
                if (this.enrollProgramType == 'PERFORMANCE_PROGRAM') {
                    this.enrollEmployeesForPerformance();
                }
                if (this.enrollProgramType == 'COMPETENCY_PROGRAM') {
                    this.enrollEmployeesForCompetency();
                }
                if (this.enrollProgramType == 'CHECKIN_PROGRAM') {
                    this.enrollEmployeesForCheckin();
                }
            }
        }, (reason) => {
            this.showButtonLoading = false;
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;

        });

    }
    public announcementEmployeeConfirm() {
        let confirmData: any = {
            type: 'announcement'
        }
        this.share.saveData(confirmData);
        this.modalService.open(ConfirmationComponent).result.then((result) => {
            if (result == 'confirmed') {
                if (this.type == 'Announcement') {
                    this.triggerAnnouncement();
                }
            }
        }, (reason) => {
            this.showButtonLoading = false;
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;

        });
    }
    public enrollEmployeesForPerformance() {
        this.showButtonLoading = true;
        this.enrollEmployeesPayload.employeeSearchFilter = this.searchData;
        this.enrollEmployeesPayload.programId = this.enrollProgramId;
        delete this.enrollEmployeesPayload['type'];
        let url = this._baseUrl + 'v1/webAdmin/performance/enroll';
        this.http.post(url, this.enrollEmployeesPayload).subscribe((result) => {
            let notExistEmp: any = [];
            if (result.success) {
                this.translate.get('enrolledForValidEmployees').subscribe((msg) => {
                    this._toaster.showSuccess(msg);
                });
                setTimeout(() => this.goToBackPage(), 500);
            } else {
                let data = result.data;
                _.each(data, function (val) {
                    if (val.validationMessage === 'NOT_EXIST_IN_SYSTEM') {
                        notExistEmp.push(val.empCodes);
                    }
                });
                this.invalidEmp = notExistEmp;
                if (result.data[0].validationMessage === 'EMPLOYEES_ALREADY_INCLUDED_IN_PROGRAM') {
                    this.translate.get('empIncludedAlready').subscribe((msg) => {
                        this._toaster.showError(msg)
                    });

                    return false;
                }
            }
        })
        this.showButtonLoading = false;
    }


    public enrollEmployeesForCompetency() {
        this.showButtonLoading = true;
        this.enrollCompetency.employeeSearchFilter = this.searchData;
        this.enrollCompetency.programId = this.enrollProgramId;
        // delete this.enrollEmployeesPayload['type'];
        let url = this._baseUrl + 'v1/webAdmin/competency/enroll';
        let data: any = {
            employeeCodes: this.empCodeValues.split(','),
            programId: this.programId
        };
        this.http.post(url, this.enrollCompetency).subscribe((result) => {
            let notExistEmp: any = [];
            if (result.success) {
                this.translate.get('enrolledForValidEmployees').subscribe((msg) => {
                    this._toaster.showSuccess(msg);
                });
                setTimeout(() => this.goToBackPage(), 500);
            } else {
                let data = result.data;
                _.each(data, function (val) {
                    if (val.validationMessage === 'NOT_EXIST_IN_SYSTEM') {
                        notExistEmp.push(val.empCodes);
                    }
                });
                this.invalidEmp = notExistEmp;
                if (result.data[0].validationMessage === 'EMPLOYEES_ALREADY_INCLUDED_IN_PROGRAM') {
                    this.translate.get('empIncludedAlready').subscribe((msg) => {
                        this._toaster.showError(msg)
                    });

                    return false;
                }
            }
        })
        this.showButtonLoading = false;
    }

    public enrollEmployeesForCheckin() {
        this.showButtonLoading = true;
        this.enrollCompetency.employeeSearchFilter = this.searchData;
        this.enrollCompetency.programId = this.enrollProgramId;
        // delete this.enrollEmployeesPayload['type'];
        let url = this._baseUrl + 'v1/webAdmin/checkins/enroll';
        let data: any = {
            employeeCodes: this.empCodeValues.split(','),
            programId: this.programId
        };
        this.http.post(url, this.enrollCompetency).subscribe((result) => {
            let notExistEmp: any = [];
            if (result.success) {
                this.translate.get('enrolledForValidEmployees').subscribe((msg) => {
                    this._toaster.showSuccess(msg);
                });
                setTimeout(() => this.goToBackPage(), 500);
            } else {
                let data = result.data;
                _.each(data, function (val) {
                    if (val.validationMessage === 'NOT_EXIST_IN_SYSTEM') {
                        notExistEmp.push(val.empCodes);
                    }
                });
                this.invalidEmp = notExistEmp;
                if (result.data[0].validationMessage === 'EMPLOYEES_ALREADY_INCLUDED_IN_PROGRAM') {
                    this.translate.get('empIncludedAlready').subscribe((msg) => {
                        this._toaster.showError(msg)
                    });

                    return false;
                }
            }
        })
        this.showButtonLoading = false;
    }
}



// WEBPACK FOOTER //
// ./src/app/employee/employeeSearch.ts